import { render } from "./MobileAccountHeader.vue?vue&type=template&id=543b60d4"
import script from "./MobileAccountHeader.vue?vue&type=script&lang=js"
export * from "./MobileAccountHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mobile/account_center/components/MobileAccountHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "543b60d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('543b60d4', __exports__)) {
    api.reload('543b60d4', __exports__)
  }
  
  module.hot.accept("./MobileAccountHeader.vue?vue&type=template&id=543b60d4", () => {
    api.rerender('543b60d4', render)
  })

}


export default __exports__